import React, { useEffect, useState } from 'react';
import { fetchAuthenticatedBlob } from '../services/hdpFiles';

function AuthenticatedImage({ fileId, alt, style }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!fileId) return undefined;
    let objectUrl;
    let cancelled = false;

    fetchAuthenticatedBlob(`/hdp/files/${fileId}/content`)
      .then((url) => {
        if (cancelled) {
          URL.revokeObjectURL(url);
          return;
        }
        objectUrl = url;
        setSrc(url);
      })
      .catch(() => setSrc(null));

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (!fileId || !src) {
    return (
      <div style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-secondary)',
        color: 'var(--text-muted)',
        fontSize: '11px',
      }}>
        No photo
      </div>
    );
  }

  return <img src={src} alt={alt} style={style} />;
}

export default AuthenticatedImage;
